import { SidebarMainHeader } from 'shared/components/Sidebar';

export const MomentumSidebarHeader = () => {
  return <SidebarMainHeader title="Momentum Feed" />;
};
